import classNames from 'classnames';

import Button from '~components/Button/Button';
import { usePageContext } from '~components/PageDataProvider/PageDataProvider';
import { useAppDispatch, useAppSelector } from '~hooks/useRedux';
import UserIcon from '~images/inline/user.inline.svg';
import { updateCcAction } from '~redux/Actions/UserActions';

type RenderOpts =
    | {
          btnType: 'secondary';
          guestCopy?: string;
          authenticatedCopy?: string;
          customUrl?: string;
      }
    | {
          btnType: 'link';
          guestCopy?: never;
          authenticatedCopy?: never;
          customUrl?: never;
      };

export type CreateAccountProps = RenderOpts & {
    trackingName?: string;
    styles?: string;
};

const CreateAccountLink = ({
    trackingName,
    styles,
    btnType,
    guestCopy = 'Create Account',
    authenticatedCopy = 'My Account',
    customUrl,
}: CreateAccountProps) => {
    const user = useAppSelector((state) => state.user.user);

    const dispatch = useAppDispatch();

    const handleLogin = () => dispatch(updateCcAction('CREATE_ACCOUNT'));

    let trackingLoc = trackingName;
    if (!trackingLoc) {
        const { location } = usePageContext();
        const paths = location.pathname.split('/').filter((entry) => entry !== '');
        const lastPath = paths[paths.length - 1];
        trackingLoc = lastPath.replaceAll('-', ' ');
    }

    const isSecondaryBtn = btnType === 'secondary';
    const cndtlUserIcon = isSecondaryBtn && <UserIcon alt="" className="mr-2" />;

    return !user.isLoggedIn ? (
        <Button
            styletype={btnType}
            className={classNames(styles, isSecondaryBtn && 'min-w-48')}
            data-wa-link={`${trackingLoc}: create account`}
            onClick={handleLogin}
        >
            {cndtlUserIcon} {guestCopy}
        </Button>
    ) : (
        <Button
            islink
            forceATag
            href={customUrl || `${process.env.GATSBY_EHMP_URL}myaccount/#/dashboard`}
            data-wa-link={`${trackingLoc}: dashboard`}
            data-skip-zip="true"
            styletype={btnType}
            className={classNames(
                'text-blue',
                styles,
                isSecondaryBtn && 'btn btn-secondary min-w-48 w-max'
            )}
        >
            {cndtlUserIcon} {authenticatedCopy}
        </Button>
    );
};

export default CreateAccountLink;
